import type { ApplicationSummary } from './api';

/**
 * The applications whose repository the connected GitHub account can push to.
 * Access is granted on GitHub, where applications are set up, not in Azure.
 */
export const pushableApplications = (
  applications: readonly ApplicationSummary[],
): ApplicationSummary[] => applications.filter(app => app.canPush === true);
